import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { CheckCircle } from '@phosphor-icons/react'

import { Button, Divider, Loading, Text } from '@reveni-io/reveni-ui'

import CustomerDashboardLinkAlert from '../components/CustomerDashboardLinkAlert/CustomerDashboardLinkAlert'
import useSuccess from './hooks/useSuccess'
import SuccessMessage from './SuccessMessage/SuccessMessage'
import * as Styles from './styles'

const SuccessPage = () => {
  const { orderId, returnId } = useParams()
  const { t } = useTranslation()
  const { data, loading } = useSuccess({ orderId, returnId })

  const goToStore = () => {
    if (data?.success_url) {
      window.open(data?.success_url, '_blank')
    }
  }

  return (
    <Styles.Container>
      <Loading show={loading}>
        <Styles.IconContainer>
          <CheckCircle size={80} alt="successIcon" />
        </Styles.IconContainer>
        <Text type="titleL">{t('Pago completado')}</Text>
        <SuccessMessage
          remainingAmount={Math.abs(data?.summary?.remaining_amount).toString()}
          issueExchangeAtStatus={data?.issue_exchange_at_status}
          transactionType={data?.transaction_type}
          customerEmail={data?.customer_profile?.email?.email}
          currency={data?.currency}
          storeReplyToEmail={data?.portal?.reply_to_email}
        />
        <CustomerDashboardLinkAlert customerDashboardUrl={data?.customer_dashboard_url} />
        <Divider />
        <Button fullWidth onClick={goToStore}>
          {t('Volver a la tienda')}
        </Button>
      </Loading>
    </Styles.Container>
  )
}

export default SuccessPage
